import { Controller } from "@hotwired/stimulus"
import {
  DEFAULT_VALUES,
  DATERANGEPICKER_LOCALE,
  DATE_FORMAT
} from './consts'
import { mParseDate, linkTo } from 'utils'

// Connects to data-controller="date-picker--date"
export default class extends Controller {
  static targets = [ 'date' ]
  static values = {
    ...DEFAULT_VALUES
  }

  connect() {
    // init datepicker
    const opts = {
      locale: this.getDpLocale(),
      autoUpdateInput: this.autoUpdateInputValue || false,
      singleDatePicker: true,
      alwaysShowCalendars: true,
      startDate: this.dateTargetValueToDate() || moment(),
      autoApply: true,
      drops: 'auto',
      showDropdowns: true,
      maxDate: !this.allowFutureValue && moment(),
      minDate: !this.allowPastValue && moment()
    }
    this.dp = new DateRangePicker(this.dateTarget, opts, this.onApply.bind(this))
    this.dp.element.on('apply.daterangepicker', this.onApplyManualUpdate.bind(this))
  }

  disconnect() {
    this.dp.element.off('apply.daterangepicker', this.onApplyManualUpdate.bind(this))
  }

  dateTargetValueToDate() {
    const date = mParseDate(this.dateTarget.value, this.dateFormatValue)
    return date.isValid() ? date : null
  }

  updateDate(date) {
    if (date && typeof date != 'undefined' && date.isValid()) {
      this.dateTarget.value = date.format(this.dateFormatValue)
    }
  }

  onApply(date) {
    this.updateDate(date)
    this.autoForward()
  }

  // allow_blank 問題：input 空值時點擊今日 DateRangePicker 會以為沒有變更所以不觸發 onApply
  onApplyManualUpdate(e, dp) {
    if (!this.dateTarget.value) {
      this.onApply(dp.startDate)
    }
  }

  autoSubmit() {
    if (this.autoSubmitValue) { this.dateTarget.form.requestSubmit() }
  }

  autoLinkTo() {
    const params = {}
    params[this.dateTarget.name] = this.dateTarget.value
    linkTo(params, this.currentParamsValue)
  }

  autoForward() {
    this.plaintextValue ? this.autoLinkTo() : this.autoSubmit()
  }

  getDpLocale() {
    return Object.assign(DATERANGEPICKER_LOCALE, { format: this.dateFormatValue })
  }
}
